module.exports = __webpack_public_path__ + "img/u556.114ca0f5.png";